import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';

export default (reducers) => {
  const persistedReducer = persistReducer(
    {
      key: 'unidata',
      storage,
      whitelist: ['auth', 'language', 'user', 'drawer'],
    },
    reducers
  );

  return persistedReducer;
};
